import moment from 'moment'
import micro from '@/sui/data/microOrgs'
import units from '@/sui/data/units'
import go from '@/gojs/go'
import { resistanceFilterVariables } from '@/sui/sc/microCaracteristics'

const id = {
  key: 'id',
  field: (s) => [s.id],
  name: `Identifiant unique de la fiche`
}

function field (key, field, name, characs) {
  return {
    key,
    name,
    field: (s) => [s.f[field]],
    characs
  }
}

function arrayfield (prefix, array, key, field, name, characs) {
  return {
    key: `${prefix}_${key}`,
    field: (s) => {
      const result = []
      s.f[array].forEach(
        c => {
          result.push(c[field])
        }
      )
      return result
    },
    name: name,
    characs: characs
  }
}

function ktfield (key, field, name, characs) {
  return arrayfield('kt', 'catheters', key, field, name, characs)
}

function bactfield (key, field, name, characs) {
  return arrayfield('b', 'bacteremias', key, field, name, characs)
}

function pneufield (key, field, name, characs) {
  return arrayfield('p', 'pneumopathies', key, field, name, characs)
}

function sepfield (key, field, name, characs) {
  return arrayfield('s', 'sepsis', key, field, name, characs)
}

function diainffield (key, field, name, characs) {
  return {
    key: `inf_${key}`,
    field: (s) => {
      const result = []
      s.f.catheters.forEach(
        c => {
          c.infections.forEach(
            i => {
              result.push(i[field])
            }
          )
        }
      )
      return result
    },
    name: name,
    characs: characs
  }
}

function lapse (k, bf, ef, l, d, n) {
  return {
    key: k,
    field: (s) => {
      const b = moment(bf(s.f)).hour(12)
      const e = moment(ef(s.f)).hour(12)

      if (b.year() === 1 || e.year() === 1) {
        return []
      }

      const t = l == null || e > l ? e : l
      const y = [t.diff(b, d)]
      return y
    },
    name: n
  }
}

function diamofield (k, n) {
  return {
    key: k,
    name: n,
    field: (s) => {
      const result = []
      s.f.catheters.forEach(
        c => {
          c.infections.forEach(
            i => {
              i.microOrganisms.forEach(
                mo => {
                  result.push(
                    micro.completeList.v2.find(e => e.index === mo.code).code
                  )
                }
              )
            }
          )
        }
      )
      return result
    }
  }
}

function mofield (k, p, n) {
  return {
    key: k,
    name: n,
    field: (s) => {
      const result = []
      s.f[p].forEach(
        i => {
          i.microOrganisms.forEach(
            mo => {
              result.push(
                micro.completeList.v2.find(e => e.index === mo.code).code
              )
            }
          )
        }
      )
      return result
    }
  }
}

function findMOs (f) {
  return (s) => {
    const result = []

    const list = s.f[f]
    for (let i = 0; i !== list.length; ++i) {
      const c = list.catheters[i]
      result.push(c.microOrganisms)
    }
    return result
  }
}

function severity (v) {
  return {
    key: v,
    field: (s) => {
      if (s.f.mainSeverity.code === v) {
        return [s.f.mainSeverity.value]
      }
      return []
    },
    name: `Score de sévérité ${v.toUpperCase()}`
  }
}

function hdm (p, v, f, t) {
  return [
    field(`${p}hdm${v}`, f, t),
    field(`${p}hdm${v}_tech`, `${f}Type`, `${t} - Technique`),
    field(
      `${p}hdm${v}_tech_conf`, `${f}Compliant`, `${t} - Technique conforme`
    )
  ]
}

function gants (p, v, f, fr, t) {
  const result = []

  if (f != null) {
    result.push(
      field(`${p}gants${v}`, f, t),
      field(`${p}gants${v}_type`, `${f}Type`, `${t} - Type`)
    )
  }

  if (fr != null) {
    result.push(
      field(`${p}gants${v}_retirés`, `${fr}Removal`, `${t} - Retirés`)
    )
  }

  return result
}

export default {
  availableModules: [
    'observa4',
    'reaInfADI',
    'neoInfADI',
    'diaInfADI'
  ],

  filterVariables: {
    reaInfADI: function (year) {
      return [
        field('uf', 'uf', 'Uf'),
        field('sexe', 'sex', 'Sexe du patient', ['sex']),
        lapse(
          'age', s => s.birthdate, s => s.entry,
          moment('01/01/2020', 'DD/MM/YYYY'), 'years',
          `Âge du patient (en années)`
        ),
        field('origine', 'origin', 'Provenance du patient', ['origin']),
        field('immuno', 'immuno', 'Immunodépression', ['immuno']),
        field('cancer', 'cancer', 'Cancer évolutif', ['cancer']),
        field('trauma', 'trauma', 'Patient traumatisé', ['trauma']),
        field('diagnosis', 'diagnosis', 'Catégorie diagnostique patient', ['diagnosis']),
        field('antibio', 'antibio', `Antibiotique à l'admission`, ['antibio']),
        field('imc', 'bmi', `IMC`),
        field('bmr', 'portageBmrBhre', `Portage BMR / BHRe`, ['portageBmrBhre']),
        {
          key: 'bmrmo',
          field: (s) => s.f.bmrBhreMicroOrgs,
          name: 'Micro-organisme BMR / BHre',
          characs: ['bmrMO']
        },
        field('ecmo', 'ecmo', 'ECMO', ['ecmo']),
        field('intub', 'intubated', 'Patient intubé', ['intubated']),
        field('reintub', 'reintubated', 'Patient réintubé', ['reintubated']),
        lapse(
          'duréeintub',
          s => s.intubStart, s => s.intubEnd, null, 'days',
          `Date de fin d'intubation - date de début d'intubation`
        ),
        field('décès', 'dead', 'Décès', ['dead']),
        field('covid', 'covidStatus', 'Statut COVID en fin de séjour', ['covidStatus']),
        severity('igsII'),
        severity('pimII'),
        severity('cribII'),

        ktfield('type', 'type_v2', 'Type de cathéter', ['kt_type']),
        ktfield('site', 'insertionSite', 'Site de pose', ['kt_insertionSite']),
        ktfield('retrait', 'removed', 'Retrait du cathéter', ['kt_removed']),
        ktfield('labo', 'laboratory', 'Envoi au laboratoire', ['kt_laboratory']),
        ktfield('col', 'isColIlcBlc', 'Colonisation / ILC / BLC', ['kt_isColIlcBlc']),
        ktfield(
          'diag', 'divDiag', 'Critère diagnostique colonisation / ILC / BLC',
          ['kt_divDiag']
        ),
        ktfield(
          'covid', 'covidStatus', `Statut covid lors de l'infection sur cathéter`,
          ['kt_covidStatus']
        ),
        mofield(
          'kt_mo', 'catheters', `Micro-organisme de l'infection sur cathéter`
        ),
        ...resistanceFilterVariables(year, findMOs('catheters'), 'kt'),
        {
          key: 'spe',
          name: 'Spécialité',
          field: (s) => {
            return [units[year].codeFromIndex(s.f.unitType)]
          }
        },
        bactfield('pe', 'entrance_v2', `Porte d'entrée`, ['b_entrance']),
        bactfield('origine', 'origin', 'Origine', ['b_bactOrigin']),
        bactfield('covid', 'covidStatus', 'Statut covid', ['b_covidStatus']),
        bactfield(
          'divDiag', 'divDiag',
          `Critère diagnostique pour les PE DIV (adulte et enfant)`,
          ['b_divDiag']
        ),
        bactfield(
          'neodivdiag', 'neoDivDiag',
          `Critère diagnostique pour les PE DIV (nouveau-né)`,
          ['b_neoDivDiag']
        ),
        bactfield(
          'lipides', 'lipids', 'Lipides ou alimentation parentérale',
          ['b_lipids']
        ),
        bactfield(
          'site', 'insertionSite', 'Site de pose', ['b_insertionSite']
        ),
        bactfield('ktr', 'removed', 'Retrait du cathéter', ['b_removed']),
        bactfield(
          'a13kt', 'catheter',
          `Présence d'un cathéter si PE non retrouvée (A13)`,
          ['b_catheter']
        ),
        bactfield(
          'a13typekt', 'catheterType_v2',
          `Type de catheter présent si PE non retrouvée (A13)`,
          ['b_catheterType']
        ),

        {
          key: 'p_assitb',
          name: `Associées à l'intubation (= 1) et non associées à l'intubation (= 2)`,
          field: (s) => {
            const itb = moment(s.f.intubStart).hour(12)
            if (itb.year() === 1) {
              return []
            }

            const etib = moment(s.f.intubEnd).hour(12)

            const result = []
            s.f.pneumopathies.forEach(
              p => {
                if (etib.year() === 1) {
                  result.push(2)
                  return
                }

                const ep = moment(p.episod).hour(12)
                if (ep.year() !== 1) {
                  const sdiff = ep.diff(itb, 'days')
                  const ediff = ep.diff(etib, 'days')
                  if (sdiff < 2 || ediff > 7) {
                    result.push(2)
                    return
                  }
                  result.push(1)
                } else {
                  result.push(2)
                }
              }
            )
            return result
          }
        },
        pneufield('origine', 'origin', `Origine de la pneumopathie`, ['p_pneuOrigin']),
        pneufield('covid', 'covidStatus', 'Statut covid', ['p_covidStatus']),
        pneufield(
          'pneudiag', 'diagnosis', `Critère diagnostique des pneumopathies`,
          ['p_pneuDiag']
        ),
        mofield(
          'b_mo', 'bacteremias', `Micro-organisme de la bactériémie`
        ),
        ...resistanceFilterVariables(year, findMOs('bacteremias'), 'b'),
        mofield(
          'p_mo', 'pneumopathies', `Micro-organisme de la pneumopathie`
        ),
        ...resistanceFilterVariables(year, findMOs('pneumopathies'), 'p'),
        id
      ]
    },
    neoInfADI: function (year) {
      return [
        field('uf', 'uf', 'Uf'),
        field('sexe', 'sex', 'Sexe du patient', ['sex']),
        field('origine', 'origin', 'Provenance du patient', ['origin']),
        field('site', 'birthSite', 'Lieu de naissance', ['birthSite']),
        severity('cribII'),
        field('lieu', 'birthSite', 'Lieu de naissance', ['birthSite']),
        field('leuco', 'leucomalacy', 'Leucomalacie', ['leucomalacy']),
        field('poids', 'birthWeight', 'Poids de naissance'),
        field('ageg', 'gestationalAge', 'Âge gestationnel'),
        field('décès', 'dead', 'Décès', ['dead']),
        field('futur', 'future', 'Devenir du patient', ['future']),
        field('covid', 'covidStatus', 'Statut COVID en fin de séjour', ['covidStatus']),

        ktfield('type', 'type_v2', 'Type de cathéter', ['kt_type']),
        ktfield('site', 'insertionSite', 'Site de pose', ['kt_insertionSite']),
        ktfield('mat', 'material', 'Matériau', ['kt_material']),
        ktfield('vent', 'ventilation', 'Ventilation', ['kt_ventilation']),
        ktfield('lipides', 'lipids', 'Lipides', ['kt_lipids']),
        ktfield('retrait', 'removed', 'Retrait du cathéter', ['kt_removed']),
        ktfield('raison', 'removalReason', 'Raison du retrait', ['kt_removalReason']),
        ktfield('labo', 'laboratory', 'Envoi au laboratoire', ['kt_laboratory']),
        ktfield(
          'col', 'isColIlcBlcSep', 'Colonisation / ILC / BLC / Sepsis',
          ['kt_isColIlcBlcSep']
        ),
        ktfield(
          'origine', 'colIlcBlcSepOrigin',
          'Origine de la colonisation / ILC / BLC / Sepsis',
          ['kt_colIlcBlcSepOrigin']
        ),
        ktfield(
          'lipdiag', 'lipidsDiagnosis', 'Lipides au diagnostic',
          ['kt_lipidsDiagnosis']
        ),
        ktfield(
          'critère', 'blcCriteria', 'Critère diagnostique BLC',
          ['kt_blcCriteria']
        ),
        ktfield(
          'divDiag', 'divDiag', 'Critère diagnostique BLC',
          ['kt_divDiag']
        ),
        ktfield(
          'covid', 'covidStatus', `Statut covid lors de l'infection sur cathéter`,
          ['kt_covidStatus']
        ),

        mofield(
          'kt_mo', 'catheters', `Micro-organisme de l'infection sur cathéter`
        ),

        ...resistanceFilterVariables(year, findMOs('catheters'), 'kt'),
        {
          key: 'spe',
          name: 'Spécialité',
          field: (s) => {
            return [units[year].codeFromIndex(s.f.unitType)]
          }
        },
        bactfield('pe', 'entrance_v2', `Porte d'entrée`, ['b_entrance']),
        bactfield('origine', 'origin', 'Origine', ['b_bactOrigin']),
        bactfield('covid', 'covidStatus', 'Statut covid', ['b_covidStatus']),
        bactfield(
          'divDiag', 'divDiag',
          `Critère diagnostique pour les PE DIV (adulte et enfant)`,
          ['b_divDiag']
        ),
        bactfield(
          'neodivdiag', 'neoDivDiag',
          `Critère diagnostique pour les PE DIV (nouveau-né)`,
          ['b_neoDivDiag']
        ),
        bactfield(
          'lipides', 'lipids', 'Lipides ou alimentation parentérale',
          ['b_lipids']
        ),
        bactfield(
          'site', 'insertionSite', 'Site de pose', ['b_insertionSite']
        ),
        bactfield('ktr', 'removed', 'Retrait du cathéter', ['b_removed']),

        bactfield(
          'a4uridiag', 'urinaryDiag',
          'Critère diagnostique pour les PE urinaire (A4)',
          ['b_a4urinaryDiag']
        ),
        bactfield(
          'a4uri', 'urinary',
          `Sondage urinaire dans les 7 jours avant l'épisode`,
          ['b_a4urinary']
        ),
        bactfield(
          'a3intub', 'bactintubated',
          `Patient intubé pour une PE pleuro-pulmonaire (A3)`,
          ['b_a3intubated']
        ),
        bactfield(
          'a13kt', 'catheter',
          `Présence d'un cathéter si PE non retrouvée (A13)`,
          ['b_catheter']
        ),
        bactfield(
          'a13typekt', 'catheterType_v2',
          `Type de catheter présent si PE non retrouvée (A13)`,
          ['b_catheterType']
        ),
        mofield(
          'b_mo', 'bacteremias', `Micro-organisme de la bactériémie`
        ),

        ...resistanceFilterVariables(year, findMOs('bacteremias'), 'b'),
        sepfield('pe', 'entrance_v2', `Porte d'entrée suspectée`, ['s_entrance']),
        sepfield('origine', 'origin', `Origine du sepsis`, ['s_origin']),
        sepfield('covid', 'covidStatus', 'Statut covid', ['s_covidStatus']),
        id
      ]
    },
    diaInfADI: function (year) {
      return [
        field('uf', 'uf', 'Uf'),
        lapse(
          'age', s => s.birthdate,
          s => s.entry, moment('01/01/2020', 'DD/MM/YYYY'), 'years',
          `Âge du patient (en années)`
        ),
        field('sexe', 'sex', 'Sexe du patient', ['sex']),
        field('hemodia', 'hemodiafiltr', 'Hémodiafiltration', ['hemodiafiltr']),
        field('diab', 'treatedDiab', 'Diabète traité', ['treatedDiab']),
        field('immuno', 'immuno', 'Immunodépression', ['immuno']),
        field('hygiene', 'hygiene', 'Hygiène corporelle', ['hygiene']),
        field('saur', 'previousInfect', `Antécédent d'infection à S. aureus`, ['previousInfect']),
        field('bact', 'previousBact', 'Antécédent de bactériémie', ['previousBact']),
        field('toxico', 'toxico', 'Toxicomanie active', ['toxico']),
        field('vih', 'vih', 'Sérologie VIH positive', ['vih']),
        field('vhc', 'vhc', 'Sérologie VHC positive', ['vhc']),
        field('taille', 'height', 'Taille'),
        field('poids', 'weight', 'Poids'),
        field('ferri', 'ferritinaemia', 'Ferritinémie'),
        field('sat', 'saturation', 'Coefficient de saturation'),
        field('hemog', 'hemoglobin', `Taux d'hémoglobine`),
        field('albu', 'albumin', 'Albuminémie'),
        field('creat', 'creatinine', 'Créatininémie pré-dialyse'),
        field('nbsea', 'dialNumber', 'Nombre de séances de dialyse'),
        field('cardio', 'cardioVascPb', 'Problèmes cardio-vasculaire', ['cardioVascPb']),
        field('chir', 'surgery', 'Acte chirurgical', ['surgery']),
        field('transfu', 'transfusions', 'Nombre de transfusions'),
        field('motif', 'exitReason', 'Motif de fin de suivi', ['exitReason']),
        field('covid', 'covidStatus', 'Statut COVID en fin de séjour', ['covidStatus']),

        ktfield('type', 'accessSite_v2', `Type de site d'accès`, ['kt_type']),
        ktfield('utils', 'uses', `Nombre d'utilisations`),
        ktfield(
          'incidents', 'incidents',
          `Nombre de séances avec incidents / manipulations (période suivi)`
        ),
        ktfield(
          'manip', 'unrelatedManip',
          `Nombre de manipulations sans rapport avec séance (période suivi)`
        ),
        ktfield('ablation', 'ablated', 'Ablation', ['kt_D1_ablated', 'kt_D3_ablated']),
        ktfield('fin', 'useEnded', `Arrêt d'utilisation`, ['kt_useEnded']),
        ktfield('raison', 'installReason', 'Motif de pose', ['kt_D1_installReason']),
        ktfield('tunnel', 'tunneled', 'Cathéter tunnelisé', ['kt_D1_tunneled']),
        ktfield('site', 'installSite', 'Site de pose', ['kt_D1_installSite']),
        ktfield('chsite', 'siteChanges', 'Changement de site', ['kt_D1_siteChanges']),
        ktfield('antibiopr', 'antibiopr', 'Antibioprophylaxie per op', ['kt_D1_antibiopr']),

        diainffield('inf', 'infection', `Type d'infection`, ['i_infection']),
        diainffield('origine', 'origin', 'Origine', ['i_origin']),
        diainffield('covid', 'covidStatus', 'Statut covid', ['i_covidStatus']),
        diainffield('antibio', 'antibio', 'Traitement antibiotique', ['i_antibio']),

        mofield(
          'b_mo', 'bacteremias', `Micro-organisme de l'infection sur cathéter`
        ),
        ...resistanceFilterVariables(year, findMOs('bacteremias'), 'b'),
        {
          key: 'spe',
          name: 'Spécialité',
          field: (s) => {
            return [units[year].codeFromIndex(s.f.unitType)]
          }
        },
        bactfield('pe', 'entrance_v2', `Porte d'entrée`, ['b_entrance']),
        bactfield('origine', 'origin', 'Origine', ['b_bactOrigin']),
        bactfield('covid', 'covidStatus', 'Statut covid', ['b_covidStatus']),
        bactfield(
          'divDiag', 'divDiag',
          `Critère diagnostique pour les PE DIV (adulte et enfant)`,
          ['b_divDiag']
        ),
        bactfield(
          'neodivdiag', 'neoDivDiag',
          `Critère diagnostique pour les PE DIV (nouveau-né)`,
          ['b_neoDivDiag']
        ),
        bactfield(
          'lipides', 'lipids', 'Lipides ou alimentation parentérale',
          ['b_lipids']
        ),
        bactfield('site', 'insertionSite', 'Site de pose', ['b_insertionSite']),
        bactfield('ktr', 'removed', 'Retrait du cathéter', ['b_removed']),

        bactfield(
          'a4uridiag', 'urinaryDiag',
          'Critère diagnostique pour les PE urinaire (A4)',
          ['b_a4urinaryDiag']
        ),
        bactfield(
          'a4uri', 'urinary',
          `Sondage urinaire dans les 7 jours avant l'épisode`,
          ['b_a4urinary']
        ),
        bactfield(
          'a3intub', 'bactintubated',
          `Patient intubé pour une PE pleuro-pulmonaire (A3)`,
          ['b_a3intubated']
        ),
        bactfield(
          'a13kt', 'catheter',
          `Présence d'un cathéter si PE non retrouvée (A13)`,
          ['b_catheter']
        ),
        bactfield(
          'a13typekt', 'catheterType_v2',
          `Type de catheter présent si PE non retrouvée (A13)`,
          ['b_catheterType']
        ),

        diamofield(
          'inf_mo', `Micro-organisme de la bactériémie`
        ),

        ...resistanceFilterVariables(
          year,
          (s) => {
            const result = []
            for (let i = 0; i !== s.f.catheters.length; ++i) {
              const c = s.f.catheters[i]
              for (let j = 0; j !== c.infections.length; ++j) {
                const inf = c.infections[j]
                result.push(...inf.microOrganisms)
              }
            }
            return result
          },
          'inf'
        ),
        id
      ]
    },
    observa4: function (year) {
      return [
        {
          key: 'fiche',
          field: (s) => {
            const m = s.f.obsManagment
            return [
              go.fields.obsManagment.find(
                o => o.code === m
              ).value.substring(0, 2).toLowerCase()
            ]
          },
          name: 'Type de fiche'
        },
        {
          key: 'spe',
          name: 'Spécialité',
          field: (s) => {
            return [units[year].codeFromIndex(s.f.unitType)]
          }
        },
        field('uf', 'uf', 'Uf'),
        field('lieu', 'place', 'Lieu de pose (P1)', ['p1b lieu']),
        field('ehpad', 'isEhpad', 'EHPAD (P4)', ['p4b ehpad']),

        // TODO
        field('kt', 'type', 'Dispositif (P1/P2/P4/B1/B2)'),

        field(
          'insertion', 'insertionSite', `Site d'insertion`,
          ['p1b site insertion (2023+)', 'r1b site insertion']
        ),
        field(
          'utilisation_kt', 'deviceUsage', 'Continue ou discontinue (B1/B2)',
          ['b1b utilisation cathéter (2025+)', 'b2b utilisation cathéter (2025+)']
        ),
        field(
          'type_manip', 'manipType', 'Type de manipulation',
          ['b1b manip type (2025+)', 'b2b manip type (2023+)']
        ),
        field(
          'raison_rinçage', 'isolatedRinsingReason', 'Raison du rinçage isolé (B1/B2)',
          ['b2b raison rinçage (2025+)', 'b1b raison rinçage (2025+)']
        ),

        // Audité
        field(
          'audité', 'audited', `Catégorie professionnelle de l'audité`,
          ['b1b audité', 'b2b audité', 'r1b audité', 'p1b audité',
            'p2b audité', 'p3b audité', 'p4b audité', 'p5b audité']
        ),
        field(
          'étudiant', 'student', 'Étudiant',
          ['b1b étudiant', 'b2b étudiant', 'r1b étudiant', 'p1b étudiant',
            'p2b étudiant', 'p3b étudiant', 'p4b étudiant', 'p5b étudiant']
        ),
        field(
          'aud_casaque', 'sterileGown',
          `Audité - Port d'une casaque stérile (P1/R1 neo 2024+)`,
          ['r1b casaque pour néonat (2024+)', 'p1b casaque stérile']
        ),
        field(
          'aud_coiffe', 'auditedCap', `Audité - Port d'une coiffe (P1/P3/B2/R1)`,
          ['p1b coiffe audité', 'p3b coiffe audité', 'r1b coiffe audité',
            'b2b coiffe audité (2024+)']
        ),
        field(
          'aud_coiffe_conf', 'compliantAuditedCap',
          'Audité - Port de coiffe conforme (P1/P3/B2/R1)',
          ['p1b coiffe conforme audité', 'p3b coiffe conforme audité',
            'r1b coiffe conforme audité', 'b2b coiffe conforme audité (2024+)']
        ),
        field(
          'aud_masque', 'auditedMask', `Audité - Port du masque (P1/P3/P5/B2/R1)`,
          ['p1b masque audité', 'p3b masque audité', 'p5b masque audité',
            'b2b masque audité', 'r1b masque audité']
        ),
        field(
          'aud_masque_conf', 'compliantAuditedMask',
          'Audité - Port du masque conforme (P1/P3/P5/B2/R1)',
          ['p1b masque conforme audité', 'p3b masque conforme audité', 'p5b masque conforme audité',
            'b2b masque conforme audité', 'r1b masque conforme audité']
        ),
        field(
          'aud_tenue', 'auditedCleanOutfit',
          `Audité - Port d'une tenue propre (P2/P3/P4/P5/B1/B2)`,
          ['p2b tenue propre audité', 'p3b tenue propre audité', 'p4b tenue propre audité',
            'p5b tenue propre audité', 'b1b tenue propre audité', 'b2b tenue propre audité']
        ),
        field(
          'aud_tenue_ou_protection', 'auditedCleanOutfitOrProt',
          `Audité - Port d'une tenue propre ou d'une protection (R1)`,
          ['r1b tenue propre ou prot audité']
        ),

        // Patient
        field(
          'pat_adulte', 'isAdult', 'Patient - Adulte (P1/P2/P3/R1)',
          ['p1b adulte', 'p2b adulte', 'p3b adulte', 'r1b adulte']
        ),
        field(
          'pat_age', 'childAge', `Patient - Âge de l'enfant (P1/P2/P3/R1)`,
          ['p1b âge enfant', 'p2b âge enfant', 'p3b âge enfant', 'r1b âge enfant']
        ),
        field(
          'pat_tenue', 'patientCleanOutfit',
          `Patient - Port d'une tenue propre (P1/P2/P3/P4/P5/B2)`,
          ['p1b tenue propre patient', 'p2b tenue propre patient', 'p3b tenue propre patient',
            'p4b tenue propre patient', 'p5b tenue propre patient', 'b2b tenue propre patient']
        ),
        field(
          'pat_masque', 'patientMask', 'Patient - Port du masque (P1/P3/B2/R1)',
          ['p1b masque patient', 'p3b masque patient', 'b2b masque patient',
            'r1b masque patient']
        ),
        field(
          'pat_masque_conf', 'compliantPatientMask',
          'Patient - Port du masque conforme (P1/P3/B2/R1)',
          ['p1b masque conforme patient', 'p3b masque conforme patient', 'b2b masque conforme patient',
            'r1b masque conforme patient']
        ),
        field(
          'pat_champ', 'patientSterileField', 'Patient - Champ stérile (P1/R1)',
          ['p1b visage couvert patient', 'r1b visage couvert patient']
        ),
        field(
          'pat_visage', 'patientOtherSide', 'Patient - Visage tourné (P3/B2)',
          ['p3b visage tourné patient', 'b2b visage tourné patient', 'r1b visage tourné patient']
        ),
        field(
          'pat_coiffe', 'patientCap', `Patient - Port d'une coiffe (P1)`,
          ['p1b coiffe patient']
        ),
        field(
          'pat_coiffe_conf', 'compliantPatientCap',
          'Patient - Port de coiffe conforme (P1)',
          ['p1b coiffe conforme patient']
        ),
        field(
          'pat_tete_couverte', 'patientHeadSterileField', 'Patient - Tête couverte par un champ stérile (P1)',
          ['p1b tête couverte patient (2024+)']
        ),
        field(
          'dénudation', 'strippingSufficient', 'Dénudation suffisante (R1)',
          ['r1b dénudation suffisante']
        ),
        field('imc', 'bmi', 'IMC (R1)'),
        field(
          'ref_prog', 'scheduledDressingRepair', 'Réfection programmée (R1)',
          ['r1b réfection programmée']
        ),

        // Échoguidage
        field(
          'echoguidage', 'withUltrasound', 'Pose sous échoguidage (P1/P2)',
          ['p1b echo (2023+)', 'p2b echo (2025+)']
        ),

        field(
          'echo_prepa', 'ultrasoundPrepared', 'Échographe préparé (P1)',
          ['p1b echo préparé (2023)']
        ),
        field(
          'echo_prepa_aud', 'usAuditedPreparation', `L'opérateur prépare l'échographe (P1)`,
          ['p1b echo opérateur prépare (2023)']
        ),
        field(
          'echo_prepa_essuyage', 'ultrasoundWipingPrepa', `Essuyage humide de la sonde (P1 préparation)`,
          ['p1b echo prépare essuyage (2023)']
        ),
        field(
          'echo_prepa_essuyage_prod', 'ultrasoundWipingPrepaProduct', `Produit d'essuyage (P1 préparation)`,
          ['p1b echo prépare essuyage produit (2023)']
        ),
        field(
          'echo_reper_aud', 'usAuditedSearch', `L'opérateur effectue un repérage (P1/P2)`,
          ['p1b echo opérateur repérage (2023+)', 'p2b echo opérateur repérage (2025+)']
        ),
        field(
          'echo_reper_gel', 'gelUsed', 'Gel utilisé (P1/P2 repérage)',
          ['p1b echo repère gel (2023+)', 'p2b echo repère gel (2025+)']
        ),
        field(
          'echo_flacon_date', 'vialOpeningDateWritten', `Date d'ouverture notée sur le flacon (P1/P2)`,
          ['p1b echo repère date sur flacon (2023+)', 'p2b echo repère date sur flacon (2025+)']
        ),
        field(
          'echo_flacon_ouvert', 'vialOpenedSince', 'Flacon ouvert depuis (P1/P2)',
          ['p1b echo repère flacon ouvert (2023+)', 'p2b echo repère flacon ouvert (2025+)']
        ),
        field(
          'echo_reper_gaine', 'ultrasoundSheath', 'Gaine / Housse (P1/P2 repérage)',
          ['p1b echo repère gaine (2023+)', 'p2b echo repère gaine (2025+)']
        ),
        field(
          'echo_reper_essuyage', 'ultrasoundWipingSearch', `Essuyage humide de la sonde (P1/P2 repérage)`,
          ['p1b echo repère essuyage (2023-2025)', 'p2b echo repère essuyage (2025)']
        ),
        field(
          'echo_reper_essuyage_prod', 'ultrasoundWipingSearchProduct', `Produit d'essuyage (P1/P2 repérage)`,
          ['p1b echo repère essuyage produit (2023-2025)', 'p2b echo repère essuyage produit (2025)']
        ),
        field(
          'echo_essuyage_début', 'ultrasoundWipingBeforeCare', `Essuyage humide de la sonde (P1/P2 début du soin)`,
          ['p1b echo essuyage début (2026+)', 'p2b echo essuyage début (2026+)']
        ),
        field(
          'echo_essuyage_début_prod', 'ultrasoundWipingBeforeCareProduct', `Produit d'essuyage (P1/P2 début du soin)`,
          ['p1b echo essuyage début produit (2026+)', 'p2b echo essuyage début produit (2026+)']
        ),
        field(
          'echo_reper_gaine_retire', 'sheathRemoval', 'Gaine / Housse retirée (P1/P2 repérage)',
          ['p1b echo repère gaine retrait (2023+)', 'p2b echo repère gaine retrait (2025+)']
        ),

        // Préparation du site d'insertion
        field(
          'peau', 'dirtySkin', 'Peau nécessitant un nettoyage (P1/P2/P3/P4)',
          ['p1b peau nécessitant nettoyage', 'p2b peau nécessitant nettoyage',
            'p3b peau nécessitant nettoyage', 'p4b peau nécessitant nettoyage']
        ),
        field(
          'nettoyage', 'insertionSiteCleaned',
          `Nettoyage de la zone d'insertion (P1/P2/P3/P4/P5/R1)`,
          ['p1b nettoyage', 'p2b nettoyage', 'p3b nettoyage',
            'p4b nettoyage', 'p5b nettoyage', 'r1b nettoyage']
        ),

        field(
          'nett_aud', 'auditedCleanSkin', `L'opérateur participe au nettoyage de la peau (P1)`,
          ['p1b opérateur nettoyage (2023)']
        ),

        {
          key: 'nett_savon',
          name: 'Type de savon (P1/P2/P3/P4/R1)',
          field: (s) => {
            return s.f.obsManagment === 8 ? [] : [s.f.soap]
          },
          characs: ['p1b savon', 'p2b savon', 'p3b savon', 'p4b savon', 'r1b savon']
        },

        {
          key: 'nett_savon_p5',
          name: 'Type de savon (P5)',
          field: (s) => {
            return s.f.obsManagment === 8 ? [s.f.soap] : []
          },
          characs: ['p5b savon']
        },

        field(
          'asq_aud', 'auditedApplyASQ', `L'opérateur applique l'antiseptique (P1)`,
          ['p1b opérateur antiseptique (2023)']
        ),
        field(
          'asq', 'antiseptic', 'Antiseptique',
          ['p1b antiseptique', 'p2b antiseptique', 'p3b antiseptique',
            'p4b antiseptique', 'p5b antiseptique', 'b1b antiseptique',
            'b2b antiseptique', 'r1b antiseptique']
        ),
        field(
          'appli_asq', 'antisepticApplied', `Application d'un antiseptique`,
          ['p1b application antiseptique', 'p2b application antiseptique',
            'p3b application antiseptique', 'p4b application antiseptique',
            'p5b application antiseptique', 'b1b application antiseptique',
            'b2b application antiseptique', 'r1b application antiseptique']
        ),
        field(
          'compresses', 'useCompresses', 'Utilisation de compresses',
          ['p1b compresses (2021+)', 'p2b compresses (2021+)', 'p3b compresses (2021+)',
            'p4b compresses', 'p5b compresses', 'b1b compresses (2021+)', 'b2b compresses (2021+)',
            'r1b compresses']
        ),
        field(
          'compresses_type', 'compressesType', 'Type de compresses',
          ['p1b type compresses (2021+)', 'p2b type compresses (2021+)',
            'p3b type compresses (2021+)', 'p4b type compresses',
            'p5b compresses type', 'b1b compresses type (2021+)',
            'b2b type compresses (2021+)', 'r1b compresses type']
        ),
        field(
          'asq_passages', 'antisepticPassages',
          `Nombre de passages de l'antiseptique (P1/P2/P3/P4)`
        ),
        field(
          'séchage', 'dry', 'Séchage spontané (P1/P2/P3/P4/P5/R1)',
          ['p1b séchage spontané', 'p2b séchage spontané', 'p3b séchage spontané',
            'p4b séchage spontané', 'p5b séchage spontané', 'r1b séchage spontané']
        ),
        field(
          'présence_aide', 'withHelp', `Présence d'une aide ? (B2)`,
          ['b2b présence aide (2026+)']
        ),
        field(
          'voie_abord', 'fistula', `Voie d'abord (P5)`,
          ['p5b voie abord']
        ),
        field(
          'button_hole', 'buttonHole', `Button Hole ? (P5)`,
          ['p5b button hole']
        ),
        field(
          'tablier_surblouse_audité', 'auditedOvercoat', `Port d'un tablier/surblouse à usage unique (audité, P5)`,
          ['p5b tablier surblouse audité']
        ),
        field(
          'protections_oculaires_audité', 'auditedEyeProtection', `Port de protections oculaires (audité, P5)`,
          ['p5b protections oculaires']
        ),
        field(
          'nettoyage_zone_insertion_patient', 'insertionSiteCleanedByPatient', `Néttoyage zone d'insertion par le patient (P5)`,
          ['p5b nettoyage patient']
        ),
        field(
          'rinçage_avec', 'rinsingProduct', `Produit de rinçage (P5)`,
          ['p5b rinçage avec']
        ),
        field(
          'séchage_avec', 'dryingEquipment', `Equipement pour le séchage (P5)`,
          ['p5b séchage avec']
        ),
        field(
          'champ_sterile', 'preFencedSterileField', 'Champ stérile troué préfendu (P3 2023+)',
          ['p3b champ stérile troué préfendu (2023+)']
        ),

        // Valve
        field(
          'valve', 'valve', `Utilisation d'une valve (B1/B2)`,
          ['b1b valve', 'b2b valve']
        ),
        field(
          'valve_appli_asq', 'valveAntisepticApplied',
          'Valve - Antiseptique appliqué (B1/B2)',
          ['b1b valve désinfection', 'b2b valve désinfection']
        ),
        field(
          'valve_appli_conf', 'valveAntisepticCompliant',
          'Valve - Technique de désinfection conforme (B1/B2)',
          ['b1b valve désinfection conforme', 'b2b valve désinfection conforme (2021+)']
        ),
        field(
          'valve_asq', 'valveAntiseptic', 'Valve - Antiseptique (B1/B2)',
          ['b1b valve antiseptique', 'b2b valve antiseptique']
        ),
        field(
          'gants_justifié', 'glovesJustified', 'Port de gants justifié (B1 2021-)',
          ['b1b gants justifiés (2021-)']
        ),
        field(
          'gants_nécessaires', 'glovesNecessary', 'Port de gants nécessaire (B1 2022+)',
          ['b1b gants nécessaires (2022+)']
        ),

        // Port des gants et hygiène des mains
        ...hdm('pose_', '', 'handHygiene', ` (P1 Pose) HDM`),
        ...hdm('echo_prepa_', '', 'secondaryHandHygiene', `(P1 Préparation échographe) HDM`),
        ...hdm('echo_reper_', '', 'thirdHandHygiene', `(P1 Repérage) HDM`),
        ...hdm('nett_', '', 'fourthHandHygiene', `(P1 Nettoyage) HDM`),
        ...hdm('asq_', '', 'fifthHandHygiene', `(P1 Antisepsie) HDM`),
        ...gants('pose_', '', 'gloves', null, '(P1 Pose) Gants'),
        ...gants('echo_reper_', '', 'secondaryGloves', 'gloves', '(P1 repérage) Gants'),
        ...gants('nett_', '', 'thirdGloves', 'secondaryGloves', '(P1 nettoyage) Gants'),
        ...gants('asq_', '', 'fourthGloves', 'thirdGloves', '(P1 antisepsie) Gants'),
        // SEULEMENT POUR 2023, ensuite ça devrait être glovesRemoval
        ...gants('echo_pose_touche_', '', null, 'fourthGloves', '(P1 echographe touché) Gants'),

        ...hdm('', '', 'handHygiene', `(Sauf P1) 1ère HDM`),
        ...hdm('', '2', 'secondaryHandHygiene', `(Sauf P1) 2ème HDM`),
        ...hdm('', '3', 'thirdHandHygiene', `(Sauf P1) 3ème HDM`),
        ...hdm('', '4', 'fourthHandHygiene', `(Sauf P1) 4ème HDM`),
        ...hdm('', '5', 'fifthHandHygiene', `(Sauf P1) 5ème HDM`),
        ...gants('', '', 'gloves', 'gloves', '(Sauf P1) 1ers gants'),
        ...gants('', '2', 'secondaryGloves', 'secondaryGloves', '(Sauf P1) 2èmes gants'),
        ...gants('', '3', 'thirdGloves', 'thirdGloves', '(Sauf P1) 3èmes gants'),
        ...gants('', '4', 'fourthGloves', 'fourthGloves', '(Sauf P1) 4èmes gants'),

        field(
          'gants_enfilés', 'glovesPutOn', 'Gants enfilés (P2/P3/P4/P5)',
          []
          /* ['p1b gants enfilés (2024+)', 'p2b pose gants enfilés (2022+)',
            'p3b gants enfilés (2023+)', 'p4b pose gants enfilés (2023-)',
            'p5b gants enfilés'] */
        ),

        field(
          'gants_enfilés_manip', 'glovesPutOnManip', 'Gants enfilés (B2)',
          ['b2b gants enfilés (2023+)']
        ),
        field(
          'palpation', 'palpation', `Palpation du site d'insertion (P2)`,
          ['p2b palpation']
        ),
        field(
          'maintien', 'holdTissue', `Maintien du tissu sous-cutané (P4)`,
          ['p4b maintien tissu']
        ),

        // Retrait du pansement
        field(
          'prem_pansement', 'firstDressing', `Premier pansement (R1 2023)`,
          ['r1b premier pansement (2023)']
        ),

        field(
          'pans_comp', 'dressingWithCompresses', 'Pansement en place avec compresses (R1 2023)',
          ['r1b pansement avec compresses (2023)']
        ),
        field(
          'pans_spt', 'sterileSemiPermeableTransparent', 'Pansement en place transparent semi-perméable stérile (R1 2023)',
          ['r1b pansement transparent (2023)']
        ),
        field(
          'nouv_pans_comp', 'newDressingWithCompresses', 'Pansement mis en place avec compresses (R1 2023)',
          ['r1b nouveau pansement avec compresses (2023)']
        ),
        field(
          'nouv_pans_sspt', 'newDressingSterileSemiPermeableTransparent', 'Pansement mis en place transparent semi-perméable stérile (R1 2023)',
          ['r1b nouveau pansement transparent (2023)']
        ),
        field(
          'nouv_pans_impr', 'newDressingImpregnated', `Pansement imprégné d'antiseptique (R1 2023)`,
          ['r1b nouveau pansement imprégné (2023)']
        ),

        field(
          'ref_prog', 'scheduledDressingRepair', 'Réfection programmée (R1)',
          ['r1b réfection programmée']
        ),
        field(
          'ref_souillé', 'soiledDressing', 'Pansement souillé (R1)',
          ['r1b pansement souillé']
        ),
        field(
          'ref_décolé', 'dressingPeelsOff', 'Pansement décollé (R1)',
          ['r1b pansement décollé']
        ),
        field(
          'sterile_prepa', 'sterilePreparation', 'Préparation sur champ stérile sur plan désinfecté (R1)',
          ['r1b préparation champ stérile']
        ),
        field(
          'pans_retrait', 'removeDressingByStretching', 'Retrait du pansement par étirement (R1)',
          ['r1b retrait par étirement']
        ),
        field(
          'irritation', 'signsOfSkinIrritation', `Signes d'irritation cutanée (R1)`,
          ['r1b signes irritation']
        ),

        // Stabilisateur
        field(
          'set', 'dressingSet', `Utilisation d'un set à pansement (R1 2023)`,
          ['r1b set à pansement (2023)']
        ),
        field(
          'stab_nouv', 'newStabilizer', 'Nouveau stabilisateur (R1 2023)',
          ['r1b nouveau stabilisateur (2023)']
        ),
        field(
          'anti_décollement', 'antiPeelingProduct', `Utilisation d'un produit anti-décollement (R1 2023)`,
          ['r1b anti-décollement (2023)']
        ),
        field(
          'stab', 'hasStabilizer', `Présence d'un stabilisateur (R1)`,
          ['r1b stabilisateur']
        ),
        field(
          'stab_chg', 'changeStabilizer', `Changement du stabilisateur (R1)`,
          ['r1b stab change']
        ),
        field(
          'stab_chg_raison', 'changeStabilizerReason', `Raison du changement de stabilisateur (R1)`,
          ['r1b stab change raison']
        ),
        field(
          'nett_rinçage', 'rinsing', `Rinçage avec de l'eau stérile ou du sérum phy (R1)`,
          ['r1b rinçage']
        ),
        field(
          'nett_séchage', 'dryingWithSterileCompresses', `Séchage avec compresses stériles (R1)`,
          ['r1b séchage avec compresses']
        ),

        // Pose sous échoguidage
        field(
          'echo_pose_gaine', 'secondUltrasoundSheath', `Gaine / Housse (P1/P2 pose)`,
          ['p1b echo pose gaine (2023+)', 'p2b echo pose gaine (2025+)']
        ),
        field(
          'echo_pose_gaine_recouvre', 'probeCovered', `Sonde et câble recouverts (P1/P2)`,
          ['p2b echo pose sonde recouverte (2025+)', 'p1b echo pose sonde recouverte (2023+)']
        ),
        field(
          'echo_pose_gaine_juste', 'sheathJustBeforeInsertion', 'Gaine / Housse immédiatement avant la pose (P1/P2)',
          ['p1b echo pose gaine immédiatement avant (2023-2025)',
            'p2b echo pose gaine immédiatement avant (2025)']
        ),
        field(
          'echo_pose_gel', 'secondGelUsed', 'Gel utilisé (P1/P2 pose)',
          ['p1b echo pose gel utilisé (2023+)', 'p2b echo pose gel utilisé (2025+)']
        ),
        field(
          'echo_pose_gel_appliqué', 'gelApplied', 'Gel appliqué (P1/P2 pose)',
          ['p2b echo pose gel appliqué (2025+)', 'p1b echo pose gel appliqué (2023+)']
        ),
        field(
          'echo_pose_contact', 'probeNeedleContact', 'Contact entre sonde et aiguille (P1/P2 pose)',
          ['p1b echo pose contact sonde aiguille (2023+)',
            'p2b echo pose contact sonde aiguille (2025+)']
        ),
        field(
          'echo_pose_aud_touche', 'auditedTouchProbe', `L'opérateur touche l'échographe (P1/P2 pose)`,
          ['p1b echo pose touche échographe (2023+)',
            'p2b echo pose touche échographe (2025+)']
        ),
        field(
          'echo_pose_touche_avec', 'probeTouchedWith', `Échographe touché avec (P1/P2 pose)`,
          ['p1b echo pose touche avec (2023+)', 'p2b echo pose touche avec (2025+)']
        ),
        field(
          'echo_pose_gaine_insp', 'nakedEyeSheathInspection', `Gaine / Housse inspecté à l'oeil nu (P1/P2 pose)`,
          ['p1b echo pose gaine inspectée (2023+)', 'p2b echo pose gaine inspectée (2025+)']
        ),
        field(
          'echo_pose_sonde_insp', 'probeInspection', 'Sonde (ou gel) inspecté(e) (P1/P2)',
          ['p1b echo pose sonde inspectée (2023+)', 'p2b echo pose sonde inspectée (2025+)']
        ),
        field(
          'echo_pose_déchirure', 'tearedSheath', 'Gaine / housse avec déchirure (P1/P2)',
          ['p1b echo pose sonde déchirée (2023+)', 'p2b echo pose sonde déchirée (2025+)']
        ),
        field(
          'echo_pose_sonde_sale', 'dirtyProbe', `Sonde (ou gel) avec salissures (P1/P2)`,
          ['p1b echo pose sonde sale (2023+)', 'p2b echo pose sonde sale (2025+)']
        ),
        field(
          'echo_pose_sonde_nett', 'probeCleaned', 'Sonde immédiatement entretenue (P1/P2)',
          ['p1b echo pose sonde entretenue (2023+)', 'p2b echo pose sonde entretenue (2025+)']
        ),
        field(
          'echo_pose_sonde_nett_meth', 'probeCleaningMethod', `Méthode d'entretien de la sonde (P1/P2)`,
          ['p1b echo pose sonde nettoyage (2023+)', 'p2b echo pose sonde nettoyage (2025+)']
        ),
        field(
          'echo_pose_sonde_nett_prod', 'probeCleaningProduct', `Si essuyage humide, produit utilisé (P1/P2)`,
          ['p1b echo pose sonde essuyage produit (2023+)', 'p2b echo pose sonde essuyage produit (2025+)']
        ),

        // Rinçage pulsé
        field(
          'rinçage_insertion', 'rinsingAfterCatheterInsertion', 'Rinçage après insertion',
          ['p1b rinçage après insertion (2025)', 'p2b rinçage après insertion (2025)',
            'p3b rinçage après insertion (2025)']
        ),
        field(
          'rinçage_avant_manip', 'rinsingBeforeManipulation', 'Rinçage avant manipulation',
          ['b1b rinçage avant manipulation (2025+)', 'b2b rinçage avant manipulation (2025+)']
        ),
        field(
          'rinçage_après_manip', 'rinsingAfterManipulation', 'Rinçage après manipulation',
          ['b1b rinçage après manipulation (2025+)', 'b2b rinçage après manipulation (2025+)']
        ),
        field(
          'rinçage_gants_conservés', 'insertionGlovesKeptForRinsing', 'Gants conservés pour le rinçage',
          ['p1b rinçage gants conservés (2025)', 'p3b rinçage gants conservés (2025)']
        ),
        field(
          'rinçage_capacité_seringue', 'syringeCapacity', 'Capacité de la seringue',
          ['p1b rinçage seringue capacité (2025)', 'p2b rinçage seringue capacité (2025)',
            'p3b rinçage seringue capacité (2025)', 'b1b rinçage seringue capacité (2025+)',
            'b2b rinçage seringue capacité (2025+)']
        ),
        field(
          'rinçage_capacité_seringue_autre', 'syringeCapacityOther', 'Autre capacité de la seringue'
        ),
        field(
          'rinçage_solution', 'injectedRinsingSolution', 'Solution',
          ['p1b rinçage solution (2025)', 'p2b rinçage solution (2025)',
            'p3b rinçage solution (2025)', 'b1b rinçage solution (2025+)',
            'b2b rinçage solution (2025+)']
        ),
        field(
          'rinçage_seringue_pré-remplie', 'readyPreFilledSyringe', 'Seringue pré-remplie',
          ['p1b rinçage seringue pré-remplie (2025)', 'p2b rinçage seringue pré-remplie (2025)',
            'p3b rinçage seringue pré-remplie (2025)', 'b1b rinçage seringue pré-remplie (2025+)',
            'b2b rinçage seringue pré-remplie (2025+)']
        ),
        field(
          'rinçage_seringue_monodose', 'singleDoseRinsingSolution', 'Solution stérile monodose',
          ['p1b rinçage seringue monodose (2025)', 'p2b rinçage seringue monodose (2025)',
            'p3b rinçage seringue monodose (2025)', 'b1b rinçage seringue monodose (2025+)',
            'b2b rinçage seringue monodose (2025+)']
        ),
        field(
          'rinçage_seringue_préparée_immédiatement', 'syringePreparedJustBeforeRinsing', 'Seringue préparée immédiatement',
          ['p1b rinçage seringue préparée immédiatement (2025)',
            'p2b rinçage seringue préparée immédiatement (2025)',
            'p3b rinçage seringue préparée immédiatement (2025)',
            'b1b rinçage seringue préparée immédiatement (2025+)',
            'b2b rinçage seringue préparée immédiatement (2025+)']
        ),
        field(
          'volume_injecté_rinçage', 'injectedRinsingVolume', `Volume injecté (B1/B2)`,
          ['b1b rinçage volume injecté (2026+)', 'b2b rinçage volume injecté (2026+)']
        ),
        field(
          'rinçage_poussées_successives', 'rinsingBySuccessivePushes', 'Rinçage par poussées successives',
          ['p1b rinçage poussées successives (2025)',
            'p2b rinçage poussées successives (2025)',
            'p3b rinçage poussées successives (2025)',
            'b1b rinçage poussées successives (2025+)',
            'b2b rinçage poussées successives (2025+)']
        ),
        field('rinçage_poussées_nb', 'rinsingSuccessivePushesCount', 'Nombre de poussées'),
        field(
          'rinçage_seringue_éliminée', 'syringeEliminatedImmediatelyAfterRinsing', 'Seringue éliminée immédiatement',
          ['p1b rinçage seringue éliminée (2025)',
            'p2b rinçage seringue éliminée (2025)',
            'p3b rinçage seringue éliminée (2025)',
            'b1b rinçage seringue éliminée (2025+)',
            'b2b rinçage seringue éliminée (2025+)']
        ),
        field(
          'rinçage_solution_éliminée', 'solutionContainerEliminatedImmediatelyAfterRinsing', 'Solution éliminée immédiatement',
          ['p1b rinçage solution éliminée (2025)',
            'p2b rinçage solution éliminée (2025)',
            'p3b rinçage solution éliminée (2025)',
            'b1b rinçage solution éliminée (2025+)',
            'b2b rinçage solution éliminée (2025+)']
        ),
        field(
          'pkoi_pas_rinçage_insertion', 'whyNotRinsingDoneAfterCatheterInsertion', 'Pourquoi rinçage non réalisé ?',
          ['p1b pkoi pas rinçage (2025)', 'p3b pkoi pas rinçage (2025)']
        ),
        field(
          'produit_perfusé', 'injectedProduct', 'Type de produit perfusé ?',
          ['b1b produit perfusé (2026+)', 'b2b produit perfusé (2026+)']
        ),
        field(
          'pkoi_pas_rinçage_manipulation', 'whyNotRinsingDoneWhenManipulating', 'Pourquoi rinçage non réalisé ?',
          ['b1b pkoi pas rinçage (2025+)', 'b2b pkoi pas rinçage (2025+)']
        ),

        {
          key: 'b1b2_rinçage_opportunité',
          name: 'Opportunité de rinçage pour B1 et B2',
          field: (s) => [
            s.f.manipType !== null &&
              s.f.manipType !== 5 &&
              s.f.manipType !== 6 ? 1 : 2]
        },
        {
          key: 'b1b2_rinçage_débranchement',
          name: 'Débranchement',
          field: (s) => [s.f.manipType === 2 ? 1 : 2]
        },
        {
          key: 'b2_rinçage_aiguille',
          name: 'Aiguille sur CCI',
          field: (s) => [s.f.manipType === 7 ? 1 : 2]
        },
        {
          key: 'b1b2_rinçage_branchement_continu',
          name: 'Branchement pour cathéter continu',
          field: (s) => [
            s.f.manipType === 1 &&
            s.f.deviceUsage !== null &&
            s.f.deviceUsage !== 2 ? 1 : 2
          ]
        },
        {
          key: 'b1b2_rinçage_branchement_discontinu',
          name: 'Branchement pour cathéter discontinu',
          field: (s) => [s.f.manipType === 1 && s.f.deviceUsage === 2 ? 1 : 2]
        },
        {
          key: 'b1b2_rinçage_injection_continu',
          name: 'Injection/Prélévement pour cathéter continu',
          field: (s) => [
            (s.f.manipType === 3 || s.f.manipType === 4) &&
            s.f.deviceUsage !== null && s.f.deviceUsage !== 2 ? 1 : 2
          ]
        },
        {
          key: 'b1b2_rinçage_injection_discontinu',
          name: 'Injection/Prélévement pour cathéter discontinu',
          field: (s) => [
            (s.f.manipType === 3 || s.f.manipType === 4) &&
              s.f.deviceUsage === 2 ? 1 : 2
          ]
        },

        // Entretien avec l'audité
        field(
          'q_aud_tenue_conf', 'whyNCAuditedOutfit',
          `Pourquoi la tenue audité n'est-elle pas conforme ? (P1/P2/P3/P4)`
        ),
        field(
          'q_asq_alcool', 'whyNotAlcool',
          `Pour un patient adulte, pourquoi un ASQ non alcoolique ? (P1/P2/P3/P4/P5)`
        ),
        field(
          'q_aud_gaine_repérage', 'whySheathNotRemovedAfterSearch',
          `Pourquoi l'opérateur ne retire-t-il pas la gaine après le repérage ? (P1)`
        ),
        field(
          'q_aud_chl_alc', 'whyNotChlAlc2Percent',
          `Pour un patient adulte, pourquoi l'antiseptique utilisé n'est-il-pas la chlorhexidine alcoolique 2% ? (P1)`
        ),
        field(
          'q_dcmf', 'whyNotHHC',
          `Pourquoi la désinfection chirurgicale des mains par friction n'a-t-elle
pas été réalisée ? (P1 2023-)`
        ),
        field(
          'q_aud_pas_dcmf', 'whyNotSurgicalHandrubbing',
          `Pourquoi l'opérateur ne réalise pas de désinfection chirurgicale des mains par friction ? (P1)`
        ),
        field(
          'q_aud_echo_gants_contact', 'whyNotRemoveGlovesAfterTouch',
          `Pendant l'insertion du cathéter, pourquoi l'opérateur a-t-il poursuivi l'insertion
du cathéter avec des gants ayant touchés le clavier de l'échographe ? (P1)`
        ),
        field(
          'q_hdm_insertion', 'whyNotHH',
          `Pourquoi l'HDM n'a-t-elle pas été réalisée avant l'insertion du
cathéter ? (P2/P4) ou avant d'enfiler les gants ? (P5)`
        ),
        field(
          'q_aud_gants', 'whyNotGloves',
          `Pourquoi l'opérateur n'a-t-il pas porté de gants pour la pose du
cathéter ? (P2/P4/P5)`
        ),
        field(
          'q_hdm_conf', 'whyNotHHCompliant',
          `Pourquoi la technique de l'HDM par friction n'est pas conforme ? (P2)`
        ),
        field(
          'q_hdm_conf_prérequis', 'whyNotHHCompliantPrerequisitesNotCompliant',
          `HDM par friction non conforme : pré-requis non conforme ? (P2/P5)`,
          ['p2b pkoi hdm non conforme pré-requis (2026+)', 'p5b pkoi hdm non conforme pré-requis']
        ),
        field(
          'q_hdm_conf_étapes', 'whyNotHHCompliantMissingStep',
          `HDM par friction non conforme : au moins une des sept étapes n'a pas été respectée ? (P2/P5)`,
          ['p2b pkoi hdm non conforme 7 étapes (2026+)', 'p5b pkoi hdm non conforme 7 étapes']
        ),
        field(
          'q_hdm_conf_durée', 'whyNotHHCompliantNotLongEnough',
          `HDM par friction non conforme : durée du geste insuffisante ? (P2/P5)`,
          ['p2b pkoi hdm non conforme durée (2026+)', 'p5b pkoi hdm non conforme durée']
        ),
        field(
          'q_hdm_conf_quantité_gel', 'whyNotHHCompliantNotEnoughGel',
          `HDM par friction non conforme : quantité de produit insuffisante ? (P2/P5)`,
          ['p2b pkoi hdm non conforme quantité (2026+)', 'p5b pkoi hdm non conforme quantité']
        ),
        field(
          'q_gants_palpation', 'whyNotSGForPalpation',
          `Pourquoi l'opérateur n'a-t-il pas porté de gants stériles pour la palpation
du site après l'antisepsie ? (P2)`
        ),

        field(
          'q_pat_tenue', 'whyNCPatientOutfit',
          `Pourquoi la tenue du patient n'est-elle conforme ? (P3/B2)`
        ),
        field(
          'q_hdm_manip', 'whyNotHHM',
          `Pourquoi l'HDM n'a-t-elle pas été réalisée avant la manipulation ?
(B1/B2)`
        ),

        // TODO, avant 2021 ça ne marche pas comme ça
        field(
          'q_compresses', 'whyNotCompresses',
          `Pourquoi des compresses n'ont-elles pas été utilisées ? (B1 2021+)`
        ),
        field(
          'q_compresses', 'whyNotSterileCompresses',
          `Pourquoi des compresses stériles n'ont-elles pas été utilisées ? (B1 2021+)`
        ),
        field(
          'q_valve', 'whyNotDisinfectValve',
          `Pourquoi la valve n'a-t-elle pas été désinfectée ? (B1/B2)`
        ),
        field(
          'q_hdm_ponction', 'whyNotHHP',
          `Pourquoi l'HDM n'a-t-elle pas été réalisée avant la ponction ? (P3)`
        ),

        field(
          'q_aud_masque', 'whyNotAuditedMask',
          `Pourquoi l'audité ne porte-il pas de masque chirurgical ? (B2)`
        ),

        field(
          'q_aud_gants_st', 'whyNotSterileGloves',
          `Pourquoi l'opérateur ne porte pas de gants stériles ? (B2)`
        ),

        field(
          'q_aud_gants_retrait_stab', 'whyNotGROnStabilizerChange',
          `Pourquoi les gants n'ont-ils pas été changés après le retrait du stabilisateur ? (R1)`
        ),
        field(
          'q_aud_hdm_avant_asq', 'whyNotHHBeforeAntisepsis',
          `Pourquoi l'hygiène des mains n'a-t-elle pas été réalisée avant l'antisepsie ? (R1)`
        ),
        field(
          'q_aud_gants_réfection', 'whyNotSGForAntisepsis',
          `Pourquoi les gants ne sont-ils pas stériles pour la réfection du pansement ? (R1)`
        ),
        id
      ]
    }
  }
}
